module.exports = __webpack_public_path__ + "img/Group_39939@2x.1d8a5f6a.png";